import React from "react";
import { HelpLink } from "../HelpArticle";

export interface FormHelpCalloutProps {
  title?: string;
  children: React.ReactNode;
  learnMoreHref?: string;
  learnMoreLabel?: string;
  variant?: "info" | "tip";
}

const variantStyles = {
  info: "border-white/10 bg-surface-elevated/80",
  tip: "border-brand/20 bg-brand/5",
};

export const FormHelpCallout: React.FC<FormHelpCalloutProps> = ({
  title,
  children,
  learnMoreHref,
  learnMoreLabel = "Learn more in Help",
  variant = "info",
}) => {
  return (
    <div
      className={`rounded-[14px] border px-3 py-2.5 text-xs leading-relaxed text-white/60 ${variantStyles[variant]}`}
    >
      {title ? <p className="mb-1 font-semibold text-white/75">{title}</p> : null}
      <div>{children}</div>
      {learnMoreHref ? (
        <p className="mt-2">
          <HelpLink to={learnMoreHref}>{learnMoreLabel}</HelpLink>
        </p>
      ) : null}
    </div>
  );
};
